import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../lib/supabase';
import { C } from '../lib/theme';

// Acepta watch?v=, youtu.be/, shorts/ o una URL de embed ya construida.
function getYouTubeEmbedUrl(url) {
  if (!url) return null;
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{11})/);
  return match ? `https://www.youtube.com/embed/${match[1]}?rel=0` : url;
}

export default function ContentLibraryTab({ userId, profile, kind, onKindChange }) {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [playingId, setPlayingId] = useState(null);
  const loggedRef = useRef(new Set());

  useEffect(() => {
    async function load() {
      setLoading(true);
      const { data } = await supabase
        .from('content_items')
        .select('*')
        .eq('type', kind)
        .order('sort_order');
      const persona = profile?.persona;
      const filtered = (data || []).filter(item => !item.persona_tags?.length || item.persona_tags.includes(persona));
      setItems(filtered);
      setLoading(false);
    }
    load();
  }, [kind, profile?.persona]);

  async function handleToggle(item) {
    setPlayingId(prev => (prev === item.id ? null : item.id));
    if (!loggedRef.current.has(item.id)) {
      loggedRef.current.add(item.id);
      await supabase.from('content_item_clicks').insert({
        content_item_id: item.id,
        user_id: userId,
        clinic_id: profile?.clinic_id || null,
      });
    }
  }

  return (
    <div>
      <div style={{ display: 'flex', background: '#fff', borderRadius: 12, padding: '0.3rem', marginBottom: '1rem', boxShadow: '0 1px 6px rgba(44,106,79,0.07)' }}>
        {['sport_video', 'recipe'].map(k => (
          <button
            key={k}
            onClick={() => onKindChange(k)}
            style={{
              flex: 1, padding: '0.5rem', borderRadius: 9, border: 'none', cursor: 'pointer',
              background: kind === k ? C.sage : 'transparent',
              color: kind === k ? '#fff' : C.gray,
              fontWeight: kind === k ? 700 : 400,
              fontSize: '0.82rem', transition: 'all 0.15s',
            }}
          >
            {k === 'sport_video' ? t('content.tab_sport') : t('content.tab_recipe')}
          </button>
        ))}
      </div>

      {loading ? (
        <p style={{ color: C.gray, fontSize: '0.9rem', textAlign: 'center', padding: '2rem 0' }}>{t('content.loading')}</p>
      ) : items.length === 0 ? (
        <p style={{ color: C.gray, fontSize: '0.85rem', fontStyle: 'italic', textAlign: 'center', padding: '2rem 0' }}>{t('content.empty')}</p>
      ) : (
        items.map(item => (
          <div key={item.id} style={{ background: '#fff', borderRadius: 16, padding: '1rem', boxShadow: '0 2px 12px rgba(44,106,79,0.08)', marginBottom: '0.8rem' }}>
            <div onClick={() => handleToggle(item)} style={{ cursor: 'pointer' }}>
              <h4 style={{ margin: '0 0 0.3rem', color: C.carbon, fontFamily: 'Georgia, serif', fontSize: '1rem' }}>{item.title}</h4>
              <p style={{ margin: 0, color: C.gray, fontSize: '0.85rem', lineHeight: 1.5 }}>{item.teaser}</p>
            </div>
            {playingId === item.id && (
              <div style={{ marginTop: '0.8rem', borderRadius: 10, overflow: 'hidden', position: 'relative', paddingTop: '56.25%' }}>
                <iframe
                  src={getYouTubeEmbedUrl(item.youtube_url)}
                  title={item.title}
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}
